export const LogoMark = ({ size = 30, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} data-testid="logo-mark">
    <defs>
      <linearGradient id="sr-gold" x1="0" y1="0" x2="64" y2="64">
        <stop offset="0%" stopColor="#E8DCC0" />
        <stop offset="55%" stopColor="#C9A24B" />
        <stop offset="100%" stopColor="#8A6D2F" />
      </linearGradient>
    </defs>
    <g stroke="url(#sr-gold)" strokeWidth="2" strokeLinecap="square" strokeLinejoin="miter">
      <path d="M32 1v6" />
      <path d="M21 4l3 5.5" />
      <path d="M43 4l-3 5.5" />
      <path d="M11 11l5 4" />
      <path d="M53 11l-5 4" />
      <path d="M20 24 L26 16 H38 L44 24 L32 50 Z" fill="rgba(201,162,75,0.06)" />
      <path d="M20 24 H44" />
      <path d="M26 16 L24 24 M38 16 L40 24 M32 16 V24 M24 24 L32 50 M40 24 L32 50 M32 24 V50" strokeWidth="1" />
    </g>
  </svg>
);

export const Logo = ({ size = 36, textClass = "text-2xl lg:text-3xl" }) => (
  <span className="flex items-center gap-3" data-testid="logo">
    <LogoMark size={size} />
    <span className={`font-logo font-medium uppercase tracking-[0.28em] text-white ${textClass}`}>
      Sun<span className="gold-text">rays</span>
    </span>
  </span>
);
